import { useSelector } from 'react-redux';
import {
  stripUrlProtocolForCounting,
  normalizeSmsText,
} from '../utils/textHelpers';
import { replaceAirboLinkTokens } from '../utils/airboLinkTokens';

const SAMPLE_LINK = 'https://app.airbo.com/digest/sample-00000';

// Matches Sms::Sender::OPT_OUT_FOOTER. Appended on its own line for orgs that
// have the opt-out footer turned on (Organization#sms_opt_out_footer).
const OPT_OUT_FOOTER = 'Reply STOP to opt-out.';

export const useSmsPreview = (smsBody = '') => {
  const boardName = useSelector(state => state.currentBoard.name);
  const smsOptOutFooter = useSelector(
    state => state.currentBoard.smsOptOutFooter,
  );

  const rawContent = replaceAirboLinkTokens(smsBody, SAMPLE_LINK);

  // Normalize so the preview shows exactly what will be sent (the backend
  // applies the same normalization in Sms::Normalizer before sending).
  const normalized = normalizeSmsText(rawContent);
  const wasNormalized = normalized !== rawContent;

  // Append the opt-out footer when the org has it on, mirroring the backend so
  // the preview equals what recipients receive.
  const expandedContent = smsOptOutFooter
    ? `${normalized}\n${OPT_OUT_FOOTER}`
    : normalized;

  const messageContent = stripUrlProtocolForCounting(expandedContent);
  const previewMessage = `${boardName}: ${expandedContent}`;

  return {
    boardName,
    messageContent,
    previewMessage,
    wasNormalized,
  };
};
